module.exports = __webpack_public_path__ + "img/5631f7faf24151c7840226c3059d1a1b.539d65b3.png";